const Vr1 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
           src={`https://hitimperial.github.io/VR360-12/PNG%20n.2/3d%2012-2/publish%2012-2/index.htm`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 12 Level 3 Tour"
        ></iframe>
      </div>
    );
};

export default Vr1;
